import React from 'react'
import { Box, Typography } from '@mui/material'
import { motion } from 'framer-motion'
import CheckIcon from '@mui/icons-material/Check'
import { fonts } from '@zuto/theme/src/mui/Typography'
import { formlessColors } from '@zuto/theme/src/mui/Colors'
import { InterstitialStage } from '../../../../../types/ui'

const MotionBox = motion(Box)

type StageCopyProps = {
  stage: InterstitialStage
  isPreapproved?: boolean
}

const bodyTextStyles = {
  color: formlessColors.bodyTextMuted,
  maxWidth: '420px',
  marginLeft: 'auto',
  marginRight: 'auto',
  lineHeight: 1.5
} as const

const StageCopy: React.FC<StageCopyProps> = ({ stage, isPreapproved }) => {
  if (stage === 'complete') {
    return (
      <>
        <MotionBox
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: 'spring', stiffness: 200, damping: 15 }}
          sx={{
            width: '64px',
            height: '64px',
            borderRadius: '50%',
            backgroundColor: formlessColors.accentGreen,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 24px',
            boxShadow: '0 10px 25px rgba(44,192,146,0.35)'
          }}
        >
          <CheckIcon sx={{ fontSize: '32px', color: 'common.white' }} />
        </MotionBox>
        <Typography
          component="h1"
          sx={{
            fontFamily: fonts.bold,
            fontSize: '36px',
            lineHeight: 1.2,
            marginBottom: '12px'
          }}
        >
          Welcome to Zuto
        </Typography>
        <Typography sx={bodyTextStyles}>Your offer is ready. Let&apos;s get you started on finding your perfect car.</Typography>
      </>
    )
  }

  if (stage === 'intro') {
    return (
      <>
        <Typography
          component="h1"
          sx={{
            fontFamily: fonts.bold,
            fontSize: '32px',
            lineHeight: 1.2,
            marginBottom: '12px'
          }}
        >
          Transferring you to Zuto
        </Typography>
        <Typography sx={bodyTextStyles}>ClearScore has partnered with Zuto to give you exclusive access to car finance.</Typography>
      </>
    )
  }

  return (
    <>
      <Typography
        component="h1"
        sx={{
          fontFamily: fonts.bold,
          fontSize: '32px',
          lineHeight: 1.2,
          marginBottom: '12px'
        }}
      >
        Securing your offer
      </Typography>
      <Typography sx={bodyTextStyles}>
        {isPreapproved ? "We're safely transferring your pre-approved finance details to Zuto." : "We're safely transferring your application details to Zuto."}
      </Typography>
    </>
  )
}

export default StageCopy
